"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findNodes = findNodes;
exports.flattenText = flattenText;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function nodeName(node) {
  if (typeof node === 'string') return node;
  return node.name.toString();
}

function findNodes(elementOrComponent, currentNode) {
  if (!currentNode.isArray) {
    if (currentNode.node === undefined) return [];

    if (nodeName(elementOrComponent) === nodeName(currentNode.node)) {
      return [currentNode];
    }
  }

  var result = [];

  for (var i = 0; i < currentNode.tree.length; i += 1) {
    var currentChild = currentNode.tree[i];
    var childResult = findNodes(elementOrComponent, currentChild);

    if (childResult.constructor !== Array) {
      childResult = [childResult];
    }

    result = [].concat(_toConsumableArray(result), _toConsumableArray(childResult));
  }

  return result;
}

function mergeChildrenText(children) {
  return children.reduce(function (_final, child) {
    if (typeof child === 'string') return child + _final;
    if (typeof child === 'number') return child.toString() + _final;
    return _final;
  }, '');
}

function flattenText(currentNode) {
  var result = '';

  if (currentNode.component && currentNode.component.props.children) {
    var childResult = mergeChildrenText(currentNode.component.props.children);
    if (childResult.length > 0) return childResult;
  }

  for (var i = 0; i < (currentNode.tree || []).length; i += 1) {
    var currentChild = currentNode.tree[i];
    result += flattenText(currentChild);
  }

  return result;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux/dist/TestHelpers.js
// module id = 12
// module chunks = 0